export let statement1 = "Maßgeschneiderte Lösungen für Medizinprodukte, Digitale Gesundheitsanwendungen (DiGA) und IVD-Hersteller"

export let statement2 = "Umfangreiches Know-how, Checklisten und Beratung für alle zulassungsrelevanten Inhalte von der medizinischen Zweckbestimmung bis hin zur Technischen Dokumentation"

export let statement3 = "Usability Engineering für ein erfolgreiches Produkt mit optimaler Gebrauchstauglichkeit inklusive der Erstellung der Gebrauchstauglichkeitsakte"

export let statement4 = "Qualitätsmanagement als Service nach ISO 13485"

export let statement5 = "Planung und Durchführung der klinischen Bewertung (u.a. Planerstellung, Rekrutierung, Ethikantrag, statistische Analyse, Report)"